import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].GET_ORDER_GENERATORS_FIELDS_WORKS_MATERIALS]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/materials/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].GET_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/materials/:materialId/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/materials/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].PUT_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/materials/:materialId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/materials/:materialId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/materials/:materialId/',
		requestOptions: {
			method: 'DELETE',
		},
	},

}